import {TimelineMax, TweenLite} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const SizesUtils = require('../../../viscomjs/utils/SizesUtils');
const MousemoveParallax = require('../utils/MousemoveParallax');

const _addView = (instance, config) => {
    const cont = new PIXI.Container();
    const picCont = new PIXI.Container();
    const picRevCont = new PIXI.Container();
    const picRevContOver = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');
    let pic2Img = null;
    let pic1Img2 = null;
    let pic2Img2 = null;
    let pic1Img2MSK = null;
    let pic2Img2MSK = null;
    let pic2 = null;
    const layers = [];

    const pic1Img = Shortcuts.getSprite(config.picture1, TextureCache, 'pic1Img');
    const pic1 = new PIXI.Container();
    pic1Img.anchor.set(0.5, 0.5);
    pic1Img.position.set(sizes.width * 0.5, sizes.height * 0.5);
    pic1Img.scale.set(1.05, 1.05);
    pic1.addChild(pic1Img);
    layers.push(pic1);
    pic1.z = -0.3;

    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, config.overlayColor !== void 0 ? config.overlayColor : 0x0b0b0f);


    picCont.addChild(pic1);
    if (typeof config.picture2 === 'string') {
        pic2Img = Shortcuts.getSprite(config.picture2, TextureCache, 'pic2Img');
        pic2 = new PIXI.Container();
        pic2Img.anchor.set(0.5, 0.5);
        pic2Img.position.set(sizes.width * 0.5, sizes.height * 0.5);
        pic2Img.scale.set(1.05, 1.05);
        pic2Img.alpha = 0;
        pic2.addChild(pic2Img);
        picCont.addChild(pic2);
        layers.push(pic2);
        pic2.z = -0.3;

        pic1Img2 = Shortcuts.getSprite(config.picture1, TextureCache, 'pic1Img2');
        pic2Img2 = Shortcuts.getSprite(config.picture2, TextureCache, 'pic2Img2');
        pic1Img2.anchor.set(0.5, 0.5);
        pic2Img2.anchor.set(0.5, 0.5);
        pic1Img2.scale.set(1.05, 1.05);
        pic2Img2.scale.set(1.05, 1.05);
        pic1Img2.position.set(sizes.width * 0.5, sizes.height * 0.5);
        pic2Img2.position.set(sizes.width * 0.5, sizes.height * 0.5);

        pic1Img2MSK = Shortcuts.getSprite('gradient', TextureCache, 'pic1Img2MSK');
        pic2Img2MSK = Shortcuts.getSprite('gradient', TextureCache, 'pic2Img2MSK');
        pic1Img2MSK.anchor.set(0.5, 0);
        pic1Img2MSK.scale.set(-1, 1);
        pic1Img2MSK.position.x = sizes.width / 2;

        pic1Img2.mask = pic1Img2MSK;
        pic2Img2.mask = pic2Img2MSK;

        picRevCont.addChild(pic1Img2);
        picRevCont.addChild(pic2Img2);
        picRevCont.addChild(pic1Img2MSK);
        picRevCont.addChild(pic2Img2MSK);
        picRevCont.alpha = 0;
        picRevCont.z = -0.3;
        layers.push(picRevCont);
    }
    cont.addChild(picCont);
    cont.addChild(overlay);
    picRevContOver.addChild(picRevCont);
    cont.addChild(picRevContOver);

    instance.cont = cont;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.picCont = picCont;
    instance.picRevCont = picRevCont;
    instance.picRevContOver = picRevContOver;
    instance.pic2 = pic2;
    instance.pic1 = pic1;
    instance.pic1Img = pic1Img;
    instance.pic2Img = pic2Img;
    instance.pic1Img2 = pic1Img2;
    instance.pic2Img2 = pic2Img2;
    instance.pic1Img2MSK = pic1Img2MSK;
    instance.pic2Img2MSK = pic2Img2MSK;
    instance.overlay = overlay;
    instance.overlayOn = 0;
    instance.parallaxLayers = layers;
    instance.isPortrait = false;

    if (config.overAll)
        instance.root.addChild(cont);
    else
        instance.root.addChildAt(cont, 0);



    instance.revealPicture = function () {
        if (this.overlayOn !== 1) return;
        TweenLite.to(instance.picRevCont, 0.6, {
            alpha: 1
        });
    }.bind(instance);

    instance.coverPicture = function () {
        TweenLite.to(instance.picRevCont, 0.6, {
            alpha: 0
        });
    }.bind(instance);

    instance.onResize = function () {
        const portrait = SizesUtils.winOffsetWidth() <= SizesUtils.winOffsetHeight();
        if (instance.isPortrait === portrait) return;

        TweenLite.to(instance.picRevContOver, 0.2, {
            alpha: portrait ? 0 : 1
        });

        instance.isPortrait = portrait;
    }.bind(instance);

    if (pic2) {
        if (config.overlayOpacity2 === void 0) {
            instance.showPicture2 = function () {
                if (this.overlayOn !== 1) return;
                TweenLite.to([this.pic2Img, this.pic2Img2], 0.5, {alpha: 1});
                TweenLite.to(this.pic1Img2, 0.5, {alpha: 0});
            }.bind(instance);

            instance.hidePicture2 = function () {
                TweenLite.to([this.pic2Img, this.pic2Img2], 0.5, {alpha: 0});
                TweenLite.to(this.pic1Img2, 0.5, {alpha: 1});
            }.bind(instance);
            return;
        }
        instance.showPicture2 = function () {
            if (this.overlayOn !== 1) return;
            TweenLite.to([this.pic2Img, this.pic2Img2], 0.5, {alpha: 1});
            TweenLite.to(this.pic1Img2, 0.5, {alpha: 0});
        }.bind(instance);

        instance.hidePicture2 = function () {
            TweenLite.to([this.pic2Img, this.pic2Img2], 0.5, {alpha: 0});
            TweenLite.to(this.pic1Img2, 0.5, {alpha: 1});
        }.bind(instance);
        return;
    }

    instance.showPicture2 = instance.hidePicture2 = () => {};
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _constructTimeline = (instance, config) => {
    const tl = new TimelineMax({paused: true});

    tl.set(instance.overlay, {alpha: 0});
    tl.set(instance.pic1, {alpha: 0});
    tl.set(instance, {overlayOn: 0});

    tl.to(instance.overlay, config.idleDuration, {alpha: 0}, 'set');
    tl.to(instance.pic1, 0, {alpha: 1}, 'set+=' + 0.01);
    tl.to(instance.overlay, config.transitionDuration, {alpha: config.overlayOpacity || 0.67}, 'in');
    tl.to(instance.overlay, config.fadeDuration - 0.05, {alpha: config.overlayOpacity || 0.67}, 'out');

    tl.to([instance.overlay, instance.pic1], 0.01, {alpha: 0}, 'off');
    tl.to(instance, 0, {overlayOn: 0}, 'off');

    if (instance.pic2) {
        tl.set(instance.pic2, {alpha: 0}, 'set');
        tl.to(instance.pic2, 0, {alpha: 1}, 'in+=' + config.transitionDuration * 0.5);
        tl.to(instance, 0, {overlayOn: 1}, 'in+=' + config.transitionDuration * 0.5);
        tl.to(instance.pic2, 0, {alpha: 0}, 'in+=' + config.transitionDuration + config.enabledDuration);
        tl.to(instance, 0, {overlayOn: 0}, 'in+=' + config.transitionDuration + config.enabledDuration);
        tl.to(instance.pic2, 0.01, {alpha: 0}, 'off');
    }

    if (config.addCustomTimeline) {
        config.addCustomTimeline(tl, instance, 'set', 'in', 'out', 'off');
    }

    instance.timeline = tl;
    return tl;
}

function DoublePictureWithOverlay(app, root, config) {

    const constructor = {};
    let _created = false;
    const win = window;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance, config);
        win.addEventListener('showAlternativePicture', instance.showPicture2);
        win.addEventListener('hideAlternativePicture', instance.hidePicture2);
        win.addEventListener('revealPicture', instance.revealPicture);
        win.addEventListener('coverPicture', instance.coverPicture);
        win.addEventListener('resize', instance.onResize);
        instance.onResize();

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance'], config);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        win.removeEventListener('showAlternativePicture', instance.showPicture2);
        win.removeEventListener('hideAlternativePicture', instance.hidePicture2);
        win.removeEventListener('revealPicture', instance.revealPicture);
        win.removeEventListener('coverPicture', instance.coverPicture);
        win.removeEventListener('resize', instance.onResize);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = config.idleDuration + config.transitionDuration;
    constructor.totalDuration = config.idleDuration + config.transitionDuration + config.fadeDuration;

    return constructor;
}

module.exports = DoublePictureWithOverlay;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/DoublePictureWithOverlay.js